// extracted by mini-css-extract-plugin
module.exports = {"main_layout":"styles_main_layout__2lCXD","scroller":"styles_scroller__CXC5B","content":"styles_content__13cbt"};